import { useCallback, useEffect, useRef } from 'react';

export const isNavigator = typeof navigator !== 'undefined';

export function on(obj: any, ...args: any[]) {
  if (obj && obj.addEventListener) {
    obj.addEventListener(...args);
  }
}

export function off(obj: any, ...args: any[]) {
  if (obj && obj.removeEventListener) {
    obj.removeEventListener(...args);
  }
}

const VENDOR_ID = 2655;

export const usePrinter = () => {
  const printer = useRef<any>(null);

  const onChange = useCallback(async () => {
    try {
      printer.current = await navigator.usb.requestDevice({
        filters: [{ vendorId: VENDOR_ID }],
      });

      if (printer.current) {
        await printer.current.open();
        await printer.current.selectConfiguration(1);
        await printer.current.claimInterface(0);
      }
    } catch (e) {
      console.log('Error connecting to printer', e);
    }
  }, []);

  useEffect(() => {
    if (printer) return;
    on(navigator.usb, 'devicechange', onChange);
    onChange();
    return () => {
      off(navigator.usb, 'devicechange', onChange);
    };
  }, [onChange]);

  const printZpl = useCallback(
    async (text: string) => {
      if (printer.current) {
        try {
          const data = new TextEncoder().encode(text);
          await printer.current.transferOut(1, data);
        } catch (e) {
          console.error(e);
        }
      }
    },
    [printer],
  );

  return {
    printZpl,
    connectDevice: onChange,
    printer: printer?.current,
  };
};
